export default __webpack_public_path__ + "static/media/playgame_btn.7e5288f5.png";